module.exports = __webpack_public_path__ + "static/logo-kairos-af4ee27a84296d1fc23aff2d90166bbe.png";